import React from 'react';
//TODO:preguntar porque esta el fragment 

export const Body = ({children}) => {
  return (
    <>
      {children}
    </>
  )
}